// JavaScript Document
// =================================================
// ページロード時に実行
// =================================================

// $(function(){
//   $("#header").load("/tsukitousagi/header.html", function () {
// 	window.timerSet(this);
//   });
//   $("#page-header").load("/tsukitousagi/page-header.html", function () {
// 	// 挿入直後のDOM（this）を渡す
// 		window.updateHeaderMenuHref(this);
// 	});
//   $("#footer").load("/tsukitousagi/footer.html");
// });
$(function(){
	const activeclass = "is-open",
				noscroll = "no-scroll";

	const $trigger = $("#header_menu_trigger");
	const $parent = $trigger.closest(".header_wrap");
	const $menu = $parent.find("#header_menu_target");
	const $cover = $(".hamburger_cover");

	$trigger.click(function () {
		if ($trigger.hasClass(activeclass)) {
			$trigger.removeClass(activeclass);
			$menu.removeClass(activeclass);
			$cover.removeClass(activeclass);
			$("body").removeClass(noscroll);
		} else {
			$trigger.addClass(activeclass);
			$menu.addClass(activeclass);
			$cover.addClass(activeclass);
			$("body").addClass(noscroll);
		}
	});

	$cover.click(function () {
		$trigger.removeClass(activeclass);
		$menu.removeClass(activeclass);
		$cover.removeClass(activeclass);
		$("body").removeClass(noscroll);
	});

	const timerSetTargets = document.querySelectorAll(".js-timerSet");
	if(!timerSetTargets) return;
	let i = 0;
	let j = 0;
	let k = 0;
	
	timerSetTargets.forEach((timerSetTarget) => {
		const datatype = timerSetTarget.dataset.type;
		switch (datatype) {
			case "month":
				const now = new Date();
				const currentMonth = now.getMonth() + 1; // 1-12
				// 1〜12月の漢数字
				const jpMonths = [
					"", "一月", "二月", "三月", "四月", "五月",
					"六月", "七月", "八月", "九月", "十月", "十一月", "十二月"
				];
				const currentJpMonth = jpMonths[currentMonth];
				
				const monthPattern = '今月';
				let paragraph = timerSetTarget.innerHTML;
				const replaced = paragraph.replace(monthPattern, currentJpMonth);
				if (replaced !== paragraph) {
					timerSetTarget.innerHTML = replaced;
					i++;
				}
				break;
				
				default:
					// data-openline="2025/11/30 23:29:00" data-deadline="2025/12/31 15:59:00"
					const dateCurrent = parseInt( new Date() / 1000 );
					const opendata = timerSetTarget.dataset.openline;
					const deadlinedata = timerSetTarget.dataset.deadline;
					const open = new Date( opendata );
					const openLine = parseInt( open / 1000 );
					const dead = new Date( deadlinedata );
					const deadLine = parseInt( dead / 1000 );
					if (deadLine < dateCurrent || dateCurrent < openLine) {
						timerSetTarget.remove();
						i++;
						if(dateCurrent < openLine){
							k++;
						}
						if(deadLine < dateCurrent){
							j++;
						}
					}
		}
	});

	if (i === 0 || timerSetTargets.length === 0) {
		console.log("変更内容はありません");
	} else {
		console.log("変更した内容が" + i + "あります");
		console.log("表示期間過" + j + "点");
		console.log("表示期間前" + k + "点");
	}
});

// =================================================
// アンカーリンク
// =================================================
// $(function(){
//   // #で始まるアンカーをクリックした場合に処理
//   $('a[href^="#"]').not('.exc').click(function() {
//       // スクロールの速度
//       var speed = 400; // ミリ秒
//       // アンカーの値取得
//       var href= $(this).attr("href");
//       // 移動先を取得
//       var target = $(href == "#" || href == "" ? 'html' : href);
//       // 移動先を数値で取得
//       var position = target.offset().top;

//       // スムーススクロール
//       $('body,html').animate({scrollTop:position}, speed, 'swing');
//       return false;
//   });
// });

// =================================================
// アンカーリンク（Shopifyのハッシュ付きURLに対応版）
// =================================================
$(function(){
  // リンクのhrefに「#」が含まれているものを対象にする（ただし .exc は除く）
  $('a[href*="#"]').not('.exc').click(function(e) {
      // 現在のページがトップページ（/）の場合、または同じページ内の遷移の場合だけスムーススクロールさせる
      var currentPath = window.location.pathname;
      var href = $(this).attr("href");
      
      // 先頭の「/」を取り除いた比較用のパス
      var cleanHref = href.replace(/^\//, ''); // "/#sec-news" -> "#sec-news"
      
      // もし別ページ（例: /pages/guide）にいる状態でクリックされたなら、普通にページ遷移させる
      if (currentPath !== "/" && href.indexOf('/#') === 0) {
          return true; 
      }

      // スクロールの速度
      var speed = 400; // ミリ秒
      // 移動先を取得（「/#sec-news」から「#sec-news」の部分だけを抽出して要素を探す）
      var hash = href.substring(href.indexOf('#'));
      var target = $(hash == "#" || hash == "" ? 'html' : hash);

      if (target.length) {
          // 画面のスクロール位置を調整する前に、メニューを閉じる！
          $("#header_menu_trigger").removeClass("is-open");
          $("#header_menu_target").removeClass("is-open");
          $(".hamburger_cover").removeClass("is-open");
          $("body").removeClass("no-scroll");

          // スムーススクロールを実行
          var position = target.offset().top;
          $('body,html').animate({scrollTop: position}, speed, 'swing');

          return false;
      }
  });
});



//アンドロイド判定　IE判定
$(function(){
  if (window.navigator.userAgent.toLowerCase().indexOf('msie') != -1) {//IE11以前
    $("html").addClass("ie");
  }
  const ua = navigator.userAgent;
  if(ua.indexOf('Trident') !== -1) {//IE11
    $("html").addClass("ie");
  }
  if(navigator.userAgent.indexOf('Android') > 0){
    $("html").addClass("android");
  }
});


$(function(){
  var ua = navigator.userAgent;
  if((ua.indexOf('iPhone') > 0) || ua.indexOf('iPod') > 0 || (ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0)){
  $('head').prepend('<meta name="viewport" content="width=device-width,initial-scale=1.0,minimum-scale=1.0,user-scalable=no">');
  } else {
    $('head').prepend('<meta name="viewport" content="width=1280">');
  }
});
!function(t,i){"function"==typeof define&&define.amd?define([],i):"object"==typeof module&&module.exports?module.exports=i():t.ViewportExtra=i()}("undefined"!=typeof self?self:this,function(){"use strict";var t;return(t=function(t){if(this.minWidth=this.maxWidth=null,"number"==typeof t)this.minWidth=t;else{if("object"!=typeof t)throw new Error("ViewportExtra requires an argument that is number or object");if("number"==typeof t.minWidth&&(this.minWidth=t.minWidth),"number"==typeof t.maxWidth&&(this.maxWidth=t.maxWidth),"number"==typeof this.minWidth&&"number"==typeof this.maxWidth&&this.minWidth>this.maxWidth)throw new Error("ViewportExtra requires that maxWidth is not less than minWidth")}this.applyToElement()}).prototype.applyToElement=function(){if("undefined"!=typeof window){var i=t.createContent(this,window);i&&t.element.setAttribute("content",i)}},t.createContent=function(t,i){var e,n,r;return e=n="",r=[],null!=t.minWidth&&t.minWidth===t.maxWidth?(e="width="+t.minWidth,n="initial-scale="+i.innerWidth/t.minWidth):null!=t.minWidth&&i.innerWidth<t.minWidth?(e="width="+t.minWidth,n="initial-scale="+i.innerWidth/t.minWidth):null!=t.maxWidth&&i.innerWidth>t.maxWidth&&(e="width="+t.maxWidth,n="initial-scale="+i.innerWidth/t.maxWidth),[e,n].forEach(function(t){t&&r.push(t)}),r.join(",")},t.createElement=function(){var t=document.createElement("meta");return t.setAttribute("name","viewport"),t.setAttribute("content","width=device-width,initial-scale=1"),document.head.insertBefore(t,null),t},t.element="undefined"==typeof window?null:document.querySelector('[name="viewport"]')||t.createElement(),t});

$(function(){
	var ua = navigator.userAgent;
	if((ua.indexOf('iPhone') > 0) || ua.indexOf('iPod') > 0 || (ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0)){
	$('head').prepend('<meta name="viewport" content="width=device-width,initial-scale=1.0,minimum-scale=1.0,user-scalable=no">');
	} else {
		$('head').prepend('<meta name="viewport" content="width=1280">');
	}
});

$(window).scroll(function (){
  var ua = navigator.userAgent;
  if(ua.indexOf('iPhone') > 0 || ua.indexOf('iPod') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0) {
    $(".scroll").on('touchstart', function(){
      $(this).addClass("off");
    });
  }
});

// =================================================
// スクロールフェードイン
// =================================================
$(function(){
	$(window).scroll(function (){
		$(".fadein").each(function(){
			var imgPos = $(this).offset().top;
			var scroll = $(window).scrollTop();
			var windowHeight = $(window).height();
			if (scroll > imgPos - windowHeight + windowHeight/5){
				$(this).addClass("on");
			}
		});
	});
});
$(function(){
	$(window).scroll(function (){
		$(".fadein_detail").each(function(){
			var imgPos = $(this).offset().top;
			var scroll = $(window).scrollTop();
			var windowHeight = $(window).height();
			if (scroll > imgPos - windowHeight + windowHeight/5){
				$(this).addClass("on");
			}
		});
	});
});
$(function(){
	$(window).scroll(function (){
		$(".fadein_t").each(function(){
			var imgPos = $(this).offset().top;
			var scroll = $(window).scrollTop();
			var windowHeight = $(window).height();
			if (scroll > imgPos - windowHeight + windowHeight/5){
				$(this).addClass("on");
			}
		});
	});
});
$(function(){
	$(window).scroll(function (){
		$(".fadein_b").each(function(){
			var imgPos = $(this).offset().top;
			var scroll = $(window).scrollTop();
			var windowHeight = $(window).height();
			if (scroll > imgPos - windowHeight + windowHeight/5){
				$(this).addClass("on");
			}
		});
	});
});
$(function(){
	$(window).scroll(function (){
		$(".fadein_l").each(function(){
			var imgPos = $(this).offset().top;
			var scroll = $(window).scrollTop();
			var windowHeight = $(window).height();
			if (scroll > imgPos - windowHeight + windowHeight/5){
				$(this).addClass("on");
			}
		});
	});
});
$(function(){
	$(window).scroll(function (){
		$(".fadein_r").each(function(){
			var imgPos = $(this).offset().top;
			var scroll = $(window).scrollTop();
			var windowHeight = $(window).height();
			if (scroll > imgPos - windowHeight + windowHeight/5){
				$(this).addClass("on");
			}
		});
	});
});
//他随時スクロールに反応させたいものにつける
$(function(){
	$(window).scroll(function (){
		$(".js-animation").each(function(){
			var imgPos = $(this).offset().top;
			var scroll = $(window).scrollTop();
			var windowHeight = $(window).height();
			if (scroll > imgPos - windowHeight + windowHeight/5){
				$(this).addClass("on");
			}
		});
	});
});
// 画面が読み込まれたらすぐに動かしたい場合の記述
$(function(){
	const targets = document.querySelectorAll('.js-animation_on');
	setTimeout(() => {
		targets.forEach(target => {
			target.classList.add('on');
		});
	}, "200");
});

// =================================================
// タイトル
// =================================================


// 画面が読み込まれたらすぐに動かしたい場合の記述
$(window).on('load', function () {
  //spanタグを追加する
  var element = $(".eachTextAnime");
  element.each(function () {
    var text = $(this).text();
    var textbox = "";
    text.split('').forEach(function (t, i) {
      if (t !== " ") {
        if (i < 10) {
          textbox += '<span style="animation-delay:.' + i + 's;">' + t + '</span>';
        } else {
          var n = i / 10;
          textbox += '<span style="animation-delay:' + n + 's;">' + t + '</span>';
        }

      } else {
        textbox += t;
      }
    });
    $(this).html(textbox);
  });
	setTimeout(function(){
		$('.sd_contents .eachTextAnime').each(function () {
			$(this).addClass("appeartext");
			$(this).next('h1').addClass("on");
		});
		
	},200);
	$('.index .eachTextAnime').each(function () {
		$(this).addClass("appeartext");
	});

 /* アニメーション用の関数を呼ぶ*/
});// ここまで画面が読み込まれたらすぐに動かしたい場合の記述


// =================================================
// アコーディオン
// =================================================
$(function(){
  const HEADER_SEL = '#header';
  const HIDE_CLASS = 'js-header-hide';
  const EPS = 2; // 微小スクロール無視

  const header = document.querySelector(HEADER_SEL);
  if (!header) return;

  // 直前のスクロール位置
  let lastY = window.scrollY || 0;

  // ヘッダー高さを追従
  let headerHeight = 0;
  const calcHeaderHeight = () => {
    headerHeight =
      Math.max(0, Math.round(header.getBoundingClientRect().height)) ||
      header.offsetHeight || 0;
  };
  calcHeaderHeight();

  if ('ResizeObserver' in window) {
    const ro = new ResizeObserver(calcHeaderHeight);
    ro.observe(header);
  } else {
    let t;
    window.addEventListener('resize', () => {
      clearTimeout(t);
      t = setTimeout(calcHeaderHeight, 100);
    });
  }

  window.addEventListener('load', () => {
    calcHeaderHeight(); // 初期高さを再計測
  }, { once: true });

  window.addEventListener('pageshow', (e) => {
    if (e.persisted) {
      calcHeaderHeight(); // bfcache 復帰時の高さ再計測
    }
  });

  // 方向ごとの累積移動量と方向フラグ
  let acc = 0;         // 現在の方向における累積移動量
  let lastSign = 0;    // 1 = 下方向, -1 = 上方向, 0 = 未定

  window.addEventListener('scroll', () => {
    const y = window.scrollY || 0;
    const dy = y - lastY;

    // 微小な揺れは無視
    if (Math.abs(dy) <= EPS) {
      lastY = y;
      return;
    }

    const sign = dy > 0 ? 1 : -1; // 1: 下, -1: 上

    // 方向が変わったら累積リセット
    if (sign !== lastSign) {
      acc = 0;
      lastSign = sign;
    }

    // 累積
    acc += Math.abs(dy);

    // 閾値（ヘッダー高さ）を超えたら実行
    if (sign === 1 && acc > headerHeight) {
      // 下へ headerHeight より多くスクロール → HIDE_CLASS を除去
      header.classList.add(HIDE_CLASS);
      acc = 0; // 連続発火を防ぐならリセット
    } else if (sign === -1 && acc > headerHeight) {
      // 上へ headerHeight より多くスクロール → HIDE_CLASS を付与
      header.classList.remove(HIDE_CLASS);
      acc = 0;
    }

    lastY = y;
  }, { passive: true });
});
